import { RestApiResponse } from "./RestApi";
import { BaseResponseAttributes } from "../attributes/base-attributes";
import BaseService from "./BaseService";

export class OpeningHoursService extends BaseService {
  static createOpeningHours(
    data: any
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return OpeningHoursService.getApiClient().post(
      `opening-hours/create`,
      data
    );
  }
}

export default OpeningHoursService;
